import styles from "./cartList.module.css";
import { FiEdit } from "react-icons/fi";
import ReactTooltip from "react-tooltip";
const BoxCart = ({
  item,
  index,
  customers,
  setSelectedItem,
}) => {

  
  const editHandler = () => {
    setSelectedItem(index);
    console.log(index);
    console.log("custom", customers[index]);
   
  };

  return (
    <div
      className={`  w-100  ${styles.sec}`}
      style={{
        borderRadius: " 10px",
      }}
    >
      <div className={`d-flex flex-wrap ${styles.secondry}`}>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            نام و نام خانوادگی کاربر
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.name}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            شماره موبایل
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.mobile}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تعداد کالا
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
           {item.totalProduct}
          </div>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
           تعداد ایتمها
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
                {item.totalItem}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
             مبلغ کل 
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
             {item.price}
            
          </p>
        </div>
      
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عملیات{" "}
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModalCart`}
              onClick={editHandler}
            >
              <h4 data-tip="سبد">
                <FiEdit className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
         
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxCart;
